module.exports = __webpack_public_path__ + "897b89db9258a0d5bda7bd87260ccce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/inglaterra.png
// module id = 1048
// module chunks = 0